module.exports = __webpack_public_path__ + "img/Vector.4c93a21e.svg";